import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[autocomplete]',
    standalone: false
})
/**
 * Alterates autocomplete="off" atribute on chrome because it's ignoring it in case of credentials, address or credit card data type.
 */
export class AutocompleteDirective implements OnInit {
  private _userAgent = window.navigator.userAgent;
  // IS EDGE
  private _isEdge = this._userAgent.toLowerCase().indexOf('edge') > -1;
  // IS FIREFOX
  private _isFirefox = this._userAgent.toLowerCase().indexOf('firefox') > -1;
  // IS CHROME
  private _isChrome = this._userAgent.toLowerCase().indexOf('chrome') > -1;
  // IS SAFARI
  private _isSafari = this._userAgent.toLowerCase().indexOf('safari') > -1;
  // IS OPERA
  private _isOpera = this._userAgent.toLowerCase().indexOf('opr') > -1;

  constructor(private _el: ElementRef) {}
  ngOnInit() {
    if ((this._isChrome) && (this._isSafari)) { this._isSafari = false; }
    if ((this._isChrome && this._isOpera) || (this._isChrome && this._isEdge)) { this._isChrome = false; }
    // console.log('_userAgent: ', this._userAgent);
    // console.log('_isEdge: ', this._isEdge);
    // console.log('_isFirefox: ', this._isFirefox);
    // console.log('_isChrome: ', this._isChrome);
    // console.log('_isSafari: ', this._isSafari);
    // console.log('_isOpera: ', this._isOpera);

    if (this._isChrome) {
      setTimeout(() => {
        if (this._el.nativeElement.getAttribute('type') === 'password') {
          this._el.nativeElement.setAttribute('autocomplete', 'new-password');
        } else {
          this._el.nativeElement.setAttribute('autocomplete', 'off');
        }
      });
    } else if (this._isFirefox) {
      setTimeout(() => {
        if (this._el.nativeElement.getAttribute('type') === 'password') {
          this._el.nativeElement.setAttribute('autocomplete', 'nope');
        } else {
          this._el.nativeElement.setAttribute('autocomplete', 'off');
        }
      });
    }
  }
}
